<template lang="html">
  <material-card
    :color="color"
    :title="title"
    :text="text">
    <slot
      name="filter"/>
    <busie-quote-table
      :color="color"
      :quotes="tableData"/>
    <template #actions>
      <v-spacer />
      <v-btn
        color="secondary"
        v-if="n > 25"
        flat
        @click="n -= 5">
          <v-icon>mdi-minus</v-icon>
          <v-icon>mdi-numeric-5</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        v-if="n < quotes.length"
        flat
        @click="n += 5">
          <v-icon>mdi-plus</v-icon>
          <v-icon>mdi-numeric-5</v-icon>
      </v-btn>
    </template>
  </material-card>
</template>

<script>
import QuoteTable from './QuoteTable'

export default {
  components: {
    'busie-quote-table': QuoteTable
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    title: {
      type: String,
      required: false,
      default: 'Quotes'
    },
    text: {
      type: String,
      required: false,
      text: 'Pending Trips'
    },
    quotes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    n: 25
  }),
  computed: {
    tableData () {
      return this.quotes.slice(-this.n)
    },
  }
}
</script>

<style lang="css" scoped>
</style>
